import { Component, Input } from '@angular/core';

@Component({
  selector: 'twin-outer-arc',
  templateUrl: './twin-outer-arc.component.html',
  styleUrls: ['./twin-outer-arc.component.css']
})
export class TwinOuterArcComponent {
  @Input() primaryColor!: string; // Default primary color
  @Input() secondaryColor!: string;
  @Input() thickness!: any;
  @Input() width!: any;

  ngOnInit() {
    this.width = Number(this.width) || 48;   // default to 90 if invalid
    this.thickness = Number(this.thickness) || 3; // default to 4 if invalid
  }
}
